module.exports = __webpack_public_path__ + "img/tema-3-7.e8adf94a.svg";